<homi-menu-bar class="menu-bar" />
<homi-top-bar class="top-bar" />
<div class="main" id="main-content">
  <ion-router-outlet />
</div>
<homi-more-menu class="more-menu" />
